import React, { useRef, useLayoutEffect } from 'react';
import {
  ButtonContainer,
  FormGroup,
  SectionHeading,
  SubmitButton,
  MutedText,
} from '../../../form';
import { HtmlEditor, InputNumber, InputTime } from '../../../formikBindings';

const SettingsForm: React.FC = () => {
  const firstElement = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    firstElement.current?.focus();
  }, []);

  return (
    <>
      <SectionHeading>GDPR</SectionHeading>
      <FormGroup name="dataPrivacyMessage" label="Data Privacy Message">
        <HtmlEditor name="dataPrivacyMessage" />
        <MutedText>
          Changes to the Data Privacy Message will not take effect until the the
          sites are reloaded
        </MutedText>
      </FormGroup>
      <FormGroup
        name="retainDataForInDays"
        label="How many days should visitor data be retained for?"
        required
      >
        <InputNumber
          ref={firstElement}
          name="retainDataForInDays"
          isInteger
          min="1"
          max="2550"
        />
      </FormGroup>
      <FormGroup
        name="purgeDataAt"
        label="What time should historic visitor data be purged by the background service?"
        required
      >
        <InputTime name="purgeDataAt" />
      </FormGroup>
      <SectionHeading>Auto Sign Out</SectionHeading>
      <FormGroup
        name="autoSignOutInHours"
        label="How many hours should a visitor remain signed in before being automatically signed out?"
        required
      >
        <InputNumber name="autoSignOutInHours" isInteger min="1" max="48" />
      </FormGroup>
      <ButtonContainer>
        <SubmitButton>Save</SubmitButton>
      </ButtonContainer>
    </>
  );
};

export default SettingsForm;
